import React from "react";
import type { PurchasePlace, PurchaseType } from "~/app/analytics/ga/recommendations/types";

const PurchaseTypeContext = React.createContext<PurchaseType>("unknown");
const PurchasePlaceContext = React.createContext<PurchasePlace>("unknown");

export const PurchaseTypeProvider = PurchaseTypeContext.Provider;
export const PurchasePlaceProvider = PurchasePlaceContext.Provider;

export const usePurchaseType = () => React.useContext(PurchaseTypeContext);
export const usePurchasePlace = () => React.useContext(PurchasePlaceContext);
